import { render, staticRenderFns } from "./BuyoutBatchItemJewelCreate.vue?vue&type=template&id=1692264b"
import script from "./BuyoutBatchItemJewelCreate.vue?vue&type=script&lang=js"
export * from "./BuyoutBatchItemJewelCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports